// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-green[data-v-5ab94860]{background:linear-gradient(90deg,#1193a7,#31bb38)!important}@media (max-width:500px){.data-text[data-v-5ab94860]{align-items:center}.data-text-wrapper[data-v-5ab94860]{padding:10px 0}}", ""]);
// Exports
module.exports = exports;
